import { registerPlugin } from '@capacitor/core';
const LunaSDK = registerPlugin('LunaSDK', {
    web: () => import('./web').then(m => new m.LunaSDKWeb()),
});
export * from './definitions';
export { LunaSDK };
//# sourceMappingURL=index.js.map